import { Menu, MenuItem } from '@mui/material'
import { timeIntervalValues } from '../../../util/tradePage'
import { ExtraSmallButton, NonInteractiveTooltip } from '../../custom'
import { useSelector } from 'react-redux'
import { selectOptionChainTimeInterval } from '../../../selectors/home'
import { useCallback, useState, memo } from 'react'
import { useDispatch } from 'react-redux'
import AnalyticsManager from '../../../analytics/AnalyticsManager'
import { TimeBucket } from '../../../proto/generated/common'
import commonActions from '../../../actions/common.actions'
import { OptionChainViewKey } from '../../../assets/constants'
import { useWidgetSettingsMenuProps } from '../../widgetDashboard/widgetSettingsMenuContext'

const OptionChainTimeIntervalMenu: React.FC<{ orderOptionChain?: boolean, optionChainViewKey?: OptionChainViewKey }> = ({
    orderOptionChain = false,
    optionChainViewKey: optionChainViewKeyProp
}) => {
    const optionChainViewKey = optionChainViewKeyProp ?? OptionChainViewKey.LIVE
    const chainType = orderOptionChain || optionChainViewKey === OptionChainViewKey.WIDGET ? 'extended' : 'normal'
    const timeInterval = useSelector(selectOptionChainTimeInterval(optionChainViewKey, chainType))
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement>()
    const dispatch = useDispatch()
    const menuProps = useWidgetSettingsMenuProps('center')

    const handleTimeIntervalChange = useCallback(
        (value: TimeBucket) => {
            if (value.timeSeries !== timeInterval.timeSeries || value.value !== timeInterval.value) {
                commonActions.setOptionChainTimeInterval(dispatch, {
                    timeBucket: value,
                    optionChainViewKey,
                    type: chainType
                })
            }
            AnalyticsManager.logEvent('Option Chain Time Interval Changed', { selected_value: value })
        },
        [dispatch, timeInterval, optionChainViewKey, chainType]
    )

    return (
        <>
            <NonInteractiveTooltip title="Select time interval" arrow placement="top">
                <ExtraSmallButton
                    color="inherit"
                    id="option-chain-interval-menu-button"
                    variant="outlined"
                    data-event={'Time Interval Clicked'}
                    data-event-source={'option-chain-bar'}
                    onClick={(e) => setAnchorEl(e.currentTarget)}
                    aria-haspopup="true"
                    sx={{
                        height: '32px',
                        width: '36px',
                        borderColor: (theme) => theme.palette.background.default,
                        textWrap: 'nowrap',
                        '&:not(first-child)': {
                            marginLeft: (theme) => theme.spacing(1)
                        }
                    }}
                >
                    {timeIntervalValues.find(t => t.value.value === timeInterval.value && t.value.timeSeries === timeInterval.timeSeries)?.label ?? ''}
                </ExtraSmallButton>
            </NonInteractiveTooltip>
            <Menu
                open={!!anchorEl}
                anchorEl={anchorEl}
                onClose={() => setAnchorEl(undefined)}
                {...menuProps}
                sx={{ ...menuProps.sx, '&.MuiInputBase-root': { height: '100%' } }}
            >
                {timeIntervalValues.map((t) => (
                    <MenuItem data-event={'Interval Changed'}
                        data-event-interval={t}
                        data-event-source={'option-chain-bar'} key={t.label} selected={timeInterval === t.value} onClick={() => handleTimeIntervalChange(t.value)}>
                        {t.label}
                    </MenuItem>
                ))}
            </Menu>
        </>
    )
}

export default memo(OptionChainTimeIntervalMenu)
